module.exports = __webpack_public_path__ + "img/armor-helmet-spartan.ed84c449.svg";